
import React from "react";
import { Container, Box, Typography, useTheme } from "@mui/material";

interface PageTitleProps {
  pageTitle: string;
  pageDescription?: string;
  maxWidth?: "lg" | "xl";
}

const PageTitle: React.FC<PageTitleProps> = ({
  pageTitle,
  pageDescription,
  maxWidth = "lg",
}) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";

    return (
        <Box
            sx={{
                py: 3,
                borderBottom: "1px solid",
                borderColor: "divider",
                backgroundColor: isDark ? "grey.900" : "#1f2937",
            }}
        >
            <Container maxWidth={maxWidth}>
                <Box sx={{ textAlign: "left" }}>
                    <Typography
                        variant="h4"
                        sx={{
                            mb: 1,
                            fontWeight: 700,
                            //color: "text.primary",
                            color: "#ffffff",
                            fontSize: { xs: "1.75rem", md: "2rem" },
                        }}
                    >
                        {pageTitle}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            //color: "text.secondary",
                            color: "#ffffff",
                            maxWidth: { xs: "100%", md: "80ch" },
                        }}
                    >
                        {/* Browse our comprehensive collection of Products, APIs,
                        and AI agents */}
                        {pageDescription ? pageDescription : ''}
                    </Typography>
                </Box>
            </Container>
        </Box>
    )
}

export default PageTitle;